import { Builder, withChildren } from '@builder.io/react';

import Gallery from './index';

const GalleryWithBuilderChildren = withChildren(Gallery);

Builder.registerComponent(GalleryWithBuilderChildren, {
  name: 'Gallery',
  inputs: [
    {
      name: 'tabItems',
      type: 'list',
      defaultValue: [],
      subFields: [
        { name: 'label', type: 'string' },
        { name: 'text', type: 'string' },
        { name: 'video', type: 'object', subFields: [{ name: 'src', type: 'string' }] },
        {
          name: 'image',
          type: 'object',
          subFields: [
            { name: 'src', type: 'file', allowedFileTypes: ['jpeg', 'png'] },
            { name: 'alt', type: 'string' }
          ]
        },
        {
          name: 'bullets',
          type: 'list',
          subFields: [{ name: 'text', type: 'string' }]
        },
        {
          name: 'caption',
          type: 'list',
          subFields: [
            {
              name: 'time',
              type: 'number'
            },
            {
              name: 'text',
              type: 'string'
            }
          ]
        }
      ]
    },
    {
      name: 'withCTAs',
      type: 'boolean',
      defaultValue: false
    },
    {
      showIf: "options.get('withCTAs')",
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Talk to us',
              href: '/sales',
              variant: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary', 'inverted']
            }
          ]
        }
      ]
    },
    {
      name: 'browserTitle',
      type: 'string',
      defaultValue: 'Scale'
    },
    {
      name: 'gradientColor',
      type: 'string'
    },
    {
      name: 'aspectRatio',
      type: 'string',
      defaultValue: '70.5%'
    }
  ]
});
